import React from 'react';
import ErrorIcon from 'assets/icons/alertError-icon.svg';
import { HtmlText, formatText } from 'core/i18n';
import './alertError.scss';

function alertError({ title = '', description = '' }) {
    return (
        <div className="alert-error-container">
            <img className="alert-error-img" src={ErrorIcon} alt="alert-error" />
            <div>
                <h1 className="alert-error-tile">{HtmlText(formatText(title))}</h1>
                <p className="alert-error-description">{HtmlText(formatText(description))}</p>
            </div>
        </div>
    );
}

export default alertError;
